import styled from "styled-components";

export const Container = styled.div`
  border-radius: 0px 50px 0px 50px;
  box-shadow: 10px 10px 10px 5px #080808;
  margin-top: 10px;
  display: flex;
  flex-flow: wrap column;
  justify-items: center;
  justify-content: center;
  height: 500px;
  padding: 0px 50px;
`